import { Device } from 'DeviceUtils';
import EditSelectBarPhone from './EditSelectBar';
import EditSelectBarTablet from './EditSelectBarTablet';

const EditSelectBar = Device.isTabletOrWeb ? EditSelectBarTablet : EditSelectBarPhone;
export default EditSelectBar;
